import { LegendModel } from '../../models/legend.model'

export const rolloutLegendSpeedLimit: LegendModel = {
  type: 'static',
  items: [
    {
      description: '0',
      value: 'white',
    },
    {
      description: '10',
      value: 'speed-10', // very very light red
    },
    {
      description: '20',
      value: 'speed-20', // very light red
    },
    {
      description: '30',
      value: 'speed-30', // light red
    },
    {
      description: '40',
      value: 'speed-40', // light-medium red
    },
    {
      description: '50',
      value: 'speed-50', // medium red
    },
    {
      description: '60',
      value: 'speed-60', // medium-strong red
    },
    {
      description: '70',
      value: 'speed-70', // strong red
    },
    {
      description: '80',
      value: 'speed-80', // deeper red
    },
    {
      description: '90',
      value: 'speed-90', // even deeper red
    },
    {
      description: '100',
      value: 'speed-100', // red
    },
    {
      description: '110',
      value: 'speed-110', // dark red
    },
    {
      description: '120',
      value: 'speed-120', // darker red
    },
    {
      description: '130',
      value: 'speed-130', // darkest red
    },
  ],
}

export const rolloutLegendProbability: LegendModel = {
  type: 'static',
  items: [
    {
      description: '<0.5',
      value: 'dangerous',
    },
    {
      description: '>=0.5',
      value: 'noncritical', // very very light red
    },
  ],
}
